import React, { memo } from 'react'
import { Table, TableBody, TableContainer } from '@mui/material'

import { TableHeadCustom } from '../table'

const CustomDataTable = ({
  tableHeaders,
  columnWidths,
  children,
  stickyHeader,
  size,
  sx
}) => {
  return (
    <TableContainer
      sx={{
        ...sx
      }}
    >
      <Table stickyHeader={stickyHeader} size={size}>
        <TableHeadCustom headCells={tableHeaders} columnWidths={columnWidths} />
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  )
}

export default memo(CustomDataTable)
